export enum SocialCardType {
    FEED = 'feed',
    RIGHT_RAIL = 'rightRail'
}

export default SocialCardType;
